var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckWhite = function SvgCheckWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.791,
    height: 7.62,
    viewBox: "0 0 10.791 7.62"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1309.848 162.3l-1.269-1.269 6.348-6.351 1.269 1.269zm0 0l-4.443-4.444 1.269-1.271 4.443 4.446z",
    transform: "translate(-1305.405 -154.683)"
  })));
};
export { SvgCheckWhite as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMC43OTEiIGhlaWdodD0iNy42MiIgdmlld0JveD0iMCAwIDEwLjc5MSA3LjYyIj4KICAgIDxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0xMzA5Ljg0OCAxNjIuM2wtMS4yNjktMS4yNjkgNi4zNDgtNi4zNTEgMS4yNjkgMS4yNjl6bTAgMGwtNC40NDMtNC40NDQgMS4yNjktMS4yNzEgNC40NDMgNC40NDZ6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTMwNS40MDUgLTE1NC42ODMpIi8+Cjwvc3ZnPgo=";